// extracted by mini-css-extract-plugin
export default {"dateContainer":"DyRlY6o_H3qOsMRYnMjq","date":"XCXwblOx8vl5njQYxXOd","month":"pShqWhwmS6LzH2NCGHKh","rounded":"L_fwWEm_vRnRiYzsI8Ks","altImage":"oeGPw3ig4_cWxOOwD31G"};